<template>
  <v-app
    :style="cssProps"
    class="blue-grey lighten-5"
  >
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  computed: {
    /**
     * Adds global css custom properties to the v-app element
     */
    cssProps() {
      return {
        '--primary-color': this.$vuetify.theme.primary,
        '--toolbar-height': '80px',
        '--titlebar-height': '92px',
        '--pagination-height': '210px',
        '--form-height': '180px'
      };
    }
  }
};
</script>

<!-- global styles -->
<style>
.router-view {
  position: absolute;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated {
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.title-2 {
  font-size: 18px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
}

.fw-300 {
  font-weight: 300;
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.fw-700 {
  font-weight: 700;
}

.v-sheet {
  border-radius: 9px !important;
}

.max-shadow {
  box-shadow: 0 3px 8px 0px rgba(0, 0, 0, 0.1) !important;
}

.max-maxWidth {
  max-width: 900px;
}
</style>
